import { Gradient } from '@shared-ui/components/ui/gradient'
import { GText } from '@shared-ui/components/ui/text'
import { useAppTheme } from '@shared-ui/theme'
import type { ReactNode } from 'react'
import { type StyleProp, View, type ViewStyle } from 'react-native'
import { useCreateStyles } from './styles'

export type PaymentQrProps = {
  children?: ReactNode
  caption: string
  time?: string
  isLoading?: boolean
  style?: StyleProp<ViewStyle>
  testID?: string
}

export function PaymentQr({ children, caption, time, isLoading = false, style, testID }: PaymentQrProps) {
  const styles = useCreateStyles()
  const theme = useAppTheme()
  return (
    <View testID={testID} style={[styles.root, style]}>
      <View style={styles.qr}>
        {isLoading && (
          <Gradient
            colors={theme.COLOR_GRADIENT_SKELETON}
            locations={[0.10848, 0.40807, 0.63142]}
            start={{ x: 0.3, y: 0 }}
            end={{ x: 0.7, y: 1 }}
            style={styles.skeleton}
          />
        )}
        {!isLoading && children}
      </View>
      <View style={styles.caption}>
        <GText variant="caption-14-regular" isSecondary>
          {caption}
        </GText>
        {!isLoading && time && <GText variant="caption-14-medium">{time}</GText>}
      </View>
    </View>
  )
}
